import React from 'react'
import { CoreButton } from 'src/components/core'
import { ButtonColorTypes, ButtonVariantTypes } from 'src/model/button'
import styles from './styles'
import { withStyles } from '@material-ui/core'

const MessageBoxButtons = props => {
  const { buttons, classes } = props
  return (
    <div className={classes.buttonsStyle}>
      {buttons.map((button, index) => (
        <CoreButton
          key={index}
          onClick={button.exec}
          variant={ButtonVariantTypes[button.actionType] || 'outlined'}
          color={button.color || ButtonColorTypes[button.actionType]}
          disabled={button.disabled}
        >
          {button.title}
        </CoreButton>
      ))}
    </div>
  )
}

export default withStyles(styles)(MessageBoxButtons)
